class CategoryProductSwiper extends HTMLElement {
  constructor() {
    super();
    this.swiperEl = this.querySelector(".swiper");
    this.swiper = null;
  }

  connectedCallback() {
    this.initSwiper();
    this.bindFilter();
  }

  initSwiper() {
    this.swiper = new Swiper(this.swiperEl, {
      spaceBetween: 24,
      slidesPerView: 1.15,
      observer: true,
      observeParents: true,
      watchSlidesProgress: true,
      loop: false,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
      },
    });
  }

  bindFilter() {
    const section = this.closest(".category-products");
    if (!section) return;

    section.addEventListener("click", (e) => {
      const nav = e.target.closest(".nav");
      if (!nav) return;

      const selectedTag = nav.textContent.trim().toLowerCase();

      section
        .querySelectorAll(".nav")
        .forEach((n) => n.classList.remove("active"));
      nav.classList.add("active");

      const slides = this.querySelectorAll(".swiper-slide");

      slides.forEach((slide) => {
        const card = slide.querySelector(".product-card");
        const tag = (card?.dataset.category || "").toLowerCase();

        const match = !tag || tag.includes(selectedTag);

        slide.style.display = match ? "" : "none";
      });

      this.refreshSwiper();
    });
  }

  refreshSwiper() {
    if (!this.swiper) return;

    this.swiper.updateSlides();
    this.swiper.update();
    this.swiper.slideTo(0, 0);
  }
}

customElements.define("category-product-swiper", CategoryProductSwiper);
